import React, { Fragment } from "react";
import { string, func, shape } from "prop-types";

import { TextFieldGroup } from "../../../../common/index";

const Telephone = ({ telephone, handleChange, validation }) => (
  <Fragment>
    <div className="col-12">
      <div className="form-group">
        <label htmlFor="emergencyContactTelphone">
          Emergency Contact Telephone Number
        </label>
        <TextFieldGroup
          value={telephone}
          onChange={(e) => {
            handleChange("emergencyContactTelephone", e.target.value);
          }}
          classes="register_field"
          validationMessages={validation.emergencyContactTelephone}
          onlyShowValidationAfterChange
          dontDisplayErrorMessage
        />
      </div>
    </div>
  </Fragment>
);

Telephone.propTypes = {
  validation: shape({
    telephone: string.isRequired,
  }),
  telephone: string.isRequired,
  handleChange: func.isRequired,
};

export default Telephone;
